document.addEventListener('DOMContentLoaded', function() {
let productCount = 0;
let selectedProductNumber = 0;
let selectedInput = "";
let selectedOption = "";
let customerType = "retail";
   
// Lookup product
function lookupProduct(attribute, name) {
  for (let i = 0; i < attribute.length; i++) {
    if (name === attribute[i].name) {
      return attribute[i];
    }
  }
};

//
// ––––––––––––––––––––––––––––––––––––––––
// CHECK CUSTOMER TYPE
// ––––––––––––––––––––––––––––––––––––––––
//

function checkCustomerType() {
  const bodyElement = document.body;

  if (bodyElement.classList.contains('trade-customer')) {
    customerType = "wholesale"
    console.log("Customer type is: " + customerType);
  } else {
    customerType = "retail"
    console.log("Customer type is: " + customerType);
  } 
}
setTimeout(checkCustomerType, 1000);

//
// ––––––––––––––––––––––––––––––––––––––––
// OPTIONS MODALS
// ––––––––––––––––––––––––––––––––––––––––
//

const modalOverlay = document.getElementById("modalOverlay");
const modalCloseIcon = document.querySelectorAll(".modalCloseIcon");
const modalsAll = document.querySelectorAll(".modal");
const modalShapes = document.getElementById("modalShapes");
const modalDesigns = document.getElementById("modalDesigns");
const modalColours = document.getElementById("modalColours");

// Populate modals with shape, design and colour options
function populateModals() {
  for (let i = 0; i < shapes.length; i++) {
    const shape = shapes[i].name;
    const image = shapes[i].image;
    const dimensions = shapes[i].dimensions;

    document.getElementById("gridOfShapes").innerHTML +=
      '<div class="option" data-type="productShape"><img src="' +
      image +
      '" width="100%" height="auto" /><h3>' +
      shape +
      "</h3><p>" +
      dimensions +
      "</p></div>";
  }
  for (let i = 0; i < designs.length; i++) {
    const design = designs[i].name;
    const image = designs[i].image;
    let designID = design.replace(/\s+/g, '');

    document.getElementById("gridOfDesigns").innerHTML +=
      '<div class="option" id="' + designID + '" data-type="productDesign"><img src="' + image + '" width="100%" height="auto" /><h3>' + design + "</h3></div>";
  }
  for (let i = 0; i < colours.length; i++) {
    const colour = colours[i].name;
    const image = colours[i].image;

    document.getElementById("gridOfColours").innerHTML +=
      '<div class="option" data-type="productColour"><img src="' + image + '" width="100%" height="auto" /><h3>' + colour + "</h3></div>";
  }
}
populateModals();

// Add event listeners to open corresponding modal when input is clicked
function openModals() {
  document.addEventListener("click", (event) => {
    let attributeElement = event.target.closest(".attribute");

    if (attributeElement) {
      // Open modal overlay
      modalOverlay.style.display = "block";

      // Open corresponding modal based on 'data-type'
      let type = attributeElement.getAttribute("data-type");

      // Identify which input was clicked
      selectedInput = attributeElement.id;

      // Identify which product was clicked
      selectedProductNumber = selectedInput.slice(-1);
      
      switch (type) {
        case "attributeShape":
          modalShapes.style.display = "block";
          break;
        case "attributeDesign":
          modalDesigns.style.display = "block";

          // Hide specified designs if 'bowl' is selected
          let selectedShapeID = "productShape-" + selectedProductNumber;
          let selectedShapeInput = document.getElementById(selectedShapeID);
          let selectedShapeInputValue = selectedShapeInput.value;
          selectedShapeInputValue = selectedShapeInputValue.toLowerCase();

          const HelechoDark = document.getElementById("HelechoDark");
          const CarmenFlorDark = document.getElementById("CarmenFlorDark");
          const FlorDark = document.getElementById("FlorDark");
          
          if (selectedShapeInputValue.includes("bowl")){
            HelechoDark.style.display = "none";
            CarmenFlorDark.style.display = "none";
            FlorDark.style.display = "none";
          } else {
            HelechoDark.style.display = "flex";
            CarmenFlorDark.style.display = "flex";
            FlorDark.style.display = "flex";
          }
          
          break;
        case "attributeColour":
          modalColours.style.display = "block";
          break;
        default:
          console.log(`Error: could not match data-type for'${type}'`);
      };

      // Disable scrolling of content behind modal
      document.body.classList.add("disableScroll");
    }
  });
}
openModals();

// Close modals
function closeModals() {
  modalsAll.forEach((modal) => {
    modal.style.display = "none";
    // Restore scrolling of content behind modal
    document.body.classList.remove("disableScroll");
  });
}

// Add event listener to close modals when 'X' is clicked
function closeModalFromIcon() {
  modalCloseIcon.forEach((icon) => {
    icon.addEventListener("click", function () {
      closeModals();
    });
  });
}
closeModalFromIcon();

// Add event listener to close modals when overlay is clicked
function closeModalFromOverlay() {
  modalOverlay.addEventListener("click", function () {
    closeModals();
  });
}
closeModalFromOverlay();

//
// ––––––––––––––––––––––––––––––––––––––––
// USER SELECTS OPTION
// ––––––––––––––––––––––––––––––––––––––––
//

// Get all options for shapes, designs and colours
let options = document.querySelectorAll(".option");

// Loop through each option
options.forEach((option) => {
  option.addEventListener("click", () => {
    // Get selected options' values
    let type = option.getAttribute("data-type");
    const name = option.querySelector("h3").innerHTML;
    if (option.querySelector("p")) {
      var size = option.querySelector("p").innerHTML;
    }

    // Update form input with name, size, image and helper text
    const selectedInputForUpdate = document.querySelector(`#${selectedInput} input`);
    const inputImage = document.querySelector(`#${selectedInput} .attributeImage`);
    const helperTextWrapper = document.querySelector(`#helperTextWrapper-${selectedProductNumber}`);
    const helperText = document.querySelector(`#helperText-${selectedProductNumber}`);

    switch (type) {
      case "productShape":
        selectedInputForUpdate.value = `Shape: ${name} (${size})`;
        inputImage.style.backgroundImage = `url('${lookupProduct(shapes, name).image}')`;
        helperText.innerHTML = `This product is sold as a ${lookupProduct(shapes, name).packSize} pack`;
        helperTextWrapper.style.visibility = "visible";
        checkSelectedShape();
        break;
      case "productDesign":
        selectedInputForUpdate.value = `Design: ${name}`;
        inputImage.style.backgroundImage = `url('${lookupProduct(designs, name).image}')`;
        break;
      case "productColour":
        selectedInputForUpdate.value = `Colour: ${name}`;
        inputImage.style.backgroundImage = `url('${lookupProduct(colours, name).image}')`;
        break;
      default:
        console.log("Error: could not match data-type.");
    }
    closeModals();
    calculateSubtotal();
    checkFields();
  });
});

//
// ––––––––––––––––––––––––––––––––––––––––
// UPDATE DESIGN INPUT AFTER SHAPE IS SELECTED
// ––––––––––––––––––––––––––––––––––––––––
//


function checkSelectedShape() {

  // Get value of shape input
  let selectedInputID = "productShape-" + selectedProductNumber;
  let selectedInput = document.getElementById(selectedInputID);
  let selectedInputValue = selectedInput.value;

  // Enable design input when shape is selected
  if (selectedInputValue !== null && selectedInputValue !== undefined) {
    let enableInput = "attributeDesign-" + selectedProductNumber;
    document.getElementById(enableInput).classList.remove("inputDisabled");
  }

  // Clear design input if chosen design is exluded for selected shape
  let lowerCaseSelectedInputValue = selectedInputValue.toLowerCase();
  let clearInput = "productDesign-" + selectedProductNumber;
  let clearIMG = "attributeDesign-" + selectedProductNumber;
  let clearPackPrice = "packPrice-" + selectedProductNumber;
  let clearSubtotal = "subtotal-" + selectedProductNumber;
  

  function clearDesign() {
    document.getElementById(clearInput).value = "";
    document.querySelector(`#${clearIMG} .attributeImage`).style.backgroundImage = "";
    document.querySelector(`#${clearPackPrice}`).innerHTML = "0.0 €";
    document.querySelector(`#${clearSubtotal}`).innerHTML = "0.0 €";
  }
  
  if (lowerCaseSelectedInputValue.includes("bowl")) {
    let designInputID = "productDesign-" + selectedProductNumber;
    let designInput = document.getElementById(designInputID);
    let designInputValue = designInput.value;
    designInputValue = designInputValue.replace(/\s+/g, '');
    designInputValue = designInputValue.toLowerCase();
    
    switch (designInputValue) {
      case "design:helechodark":
        clearDesign()
        break;
      case "design:carmenflordark":
        clearDesign()
        break;
      case "design:flordark":
        clearDesign()
        break;
      default:
        console.log("Design does not match excluded designs");
    }
  }
  calculateSubtotal();
}
  
//
// ––––––––––––––––––––––––––––––––––––––––
// UPDATE QUANTITIES AND PRICES
// ––––––––––––––––––––––––––––––––––––––––
//

// Update Subtotals
function calculateSubtotal() {
  let products = document.querySelectorAll(".attributesWrapper");

  for (let i = 0; i < products.length; i++) {
    // Get product ID
    let productID = products[i].id;
    let productIndex = productID.slice(-1);

    // Get shape name
    let shape = document.getElementById(`productShape-${productIndex}`).value;
    if (shape) {
      shape = shape.replace(/\s*\(.*?\)\s*/g, "");
      shape = shape.replace(/^Shape: /, "");
    }
    // Get design name
    let design = document.getElementById(`productDesign-${productIndex}`).value;
    if (design) {
      design = design.replace(/^Design: /, "");
    }
    // Get quantity
    let qty = document.getElementById(`productQuantity-${productIndex}`).value;

    if (shape && design) {
      // Get design price key
      let designObject = lookupProduct(designs, design);
      let priceKeyValue = designObject.priceKey;

      // Get corresponding shape price (which varies based on customer type)
      let shapeObject = lookupProduct(shapes, shape);

      if (customerType == "wholesale"){
        var priceKey = "wholesalePrice" + priceKeyValue;
      } else if (customerType == "retail") {
        var priceKey = "retailPrice" + priceKeyValue;
      }
      
      let price = shapeObject[priceKey];

      // Calculate subtotal
      let subtotal = price * qty;
      subtotal = Number(subtotal.toFixed(2));

      // Display subtotal as a currency
      subtotalAsCurrency = new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
      }).format(subtotal);
      document.getElementById(`subtotal-${productIndex}`).innerHTML = subtotalAsCurrency;

      // Display pack price as currency
      packPriceAsCurrency = new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
      }).format(price);
      document.getElementById(`packPrice-${productIndex}`).innerHTML = packPriceAsCurrency;
    }
    calculateTotal();
  }
}

// Calculate total
function calculateTotal() {
  let orderTotal = 0;

  let subtotals = document.querySelectorAll(".subtotal");
  subtotals.forEach(function (subtotal) {
    // Remove currency formatting and convert to number
    let string = subtotal.innerHTML;
    string = string.replace(/£/g, "").replace(/,/g, "").trim();
    // Convert to a number
    let number = Number(string);
    // Add to total
    orderTotal = orderTotal + number;
  });

  // Display total as a currency
  totalAsCurrency = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  }).format(orderTotal);
  document.getElementById("totalPrice").innerHTML = totalAsCurrency;
}

// Update price when user changes quantity
function updateQuantity() {
  const qtyInputs = document.querySelectorAll(".productQuantity");
  qtyInputs.forEach(function (input) {
    input.addEventListener("input", function () {
      calculateSubtotal();
    });
  });
}
updateQuantity();

//
// ––––––––––––––––––––––––––––––––––––––––
// ADD PRODUCT
// ––––––––––––––––––––––––––––––––––––––––
//

// Create product
function addProduct() {
  productCount++;

  const newProduct = document.createElement("section");
  newProduct.classList.add("productWrapper");

  newProduct.innerHTML = `
        
              <!-- Product-${productCount} -->
              <div class="attributesWrapper" id="product-${productCount}">
                <!-- shape-->
                <div class="attribute" id="attributeShape-${productCount}" data-type="attributeShape">
                  <div class="attributeImage"></div>
                  <input type="text" name="productShape[]" placeholder="Select Shape" readonly class="productShape" id="productShape-${productCount}" required />
                  <span class="material-symbols-outlined"> edit </span>
                </div>
                <!-- design-->
                <div class="attribute inputDisabled" id="attributeDesign-${productCount}" data-type="attributeDesign">
                  <div class="attributeImage"></div>
                  <input type="text" name="productDesign[]" placeholder="Select Design" readonly class="productDesign" id="productDesign-${productCount}" required />
                  <span class="material-symbols-outlined"> edit </span>
                </div>
                <!-- colour-->
                <div class="attribute" id="attributeColour-${productCount}" data-type="attributeColour">
                  <div class="attributeImage"></div>
                  <input type="text" name="productColour[]" placeholder="Select Colour" readonly class="productColour" id="productColour-${productCount}" required />
                  <span class="material-symbols-outlined"> edit </span>
                </div>
                <!-- quantity-->
                <div class="quantity" id="quantity">
                  <div class="labelWrapper">
                    <div class="label"><p>Packs:</p></div>
                    <input type="number" name="productQuantity[]" min="1" value="1" class="productQuantity" id="productQuantity-${productCount}" required />
                  </div>
                  <!-- helper text-->
                  <div class="helperTextWrapper" id="helperTextWrapper-${productCount}">
                    <span class="material-symbols-outlined"> info </span>
                    <p class="helperText" id="helperText-${productCount}"></p>
                  </div>
                </div>

                <div class="buttonAndSubtotalWrapper">
                  <!-- remove button -->
                  <button type="button" class="removalButton" id="remove-${productCount}">
                    <span class="material-symbols-outlined"> do_not_disturb_on </span>
                    <p>Remove product</p>
                  </button>
                  <!-- subtotal -->
                  <div class="subtotalWrapper">
                  <div class="subtotalPriceWrapper">
                    <p>Pack Price:</p>
                    <p class="packPrice" id="packPrice-${productCount}">£0.00</p>
                  </div>
                  <div class="subtotalPriceWrapper">
                    <p>Subtotal:</p>
                    <p class="subtotal" id="subtotal-${productCount}">£0.00</p>
                  </div>
                </div>
                  
                </div>
              </div>
      `;

  // Add product to DOM
  const productList = document.getElementById("productList");
  productList.insertBefore(newProduct, document.getElementById("addButton"));

  updateQuantity();
  removeProducts();
  showOrHideRemovalButtons();
  formValidation();
  checkFields();
}

// Add event listener to add button
document.getElementById("addButton").addEventListener("click", addProduct);

//
// ––––––––––––––––––––––––––––––––––––––––
// REMOVE PRODUCT
// ––––––––––––––––––––––––––––––––––––––––
//

// Add event listeners to remove product buttons
function removeProducts() {
  const removalButtons = document.querySelectorAll(".removalButton");

  removalButtons.forEach(function (button) {
    button.addEventListener("click", function (event) {
      // Identify which input was clicked
      let clickedButton = event.currentTarget.id;

      // Remove selected product
      let elementToBeRemoved = "product-" + clickedButton.slice(-1);
      elementToBeRemoved = document.getElementById(elementToBeRemoved);
      if (elementToBeRemoved) {
        elementToBeRemoved.remove();
      }

      calculateTotal();
      showOrHideRemovalButtons();
      checkFields();
    });
  });
}
removeProducts();

// Show or hide product removal buttons
function showOrHideRemovalButtons() {
  // Show buttons
  function showRemovalButtons() {
    const removalButtons = document.querySelectorAll(".removalButton");
    removalButtons.forEach((button) => {
      button.style.visibility = "visible";
    });
  }

  // Hide buttons
  function hideRemovalButtons() {
    const removalButtons = document.querySelectorAll(".removalButton");
    removalButtons.forEach((button) => {
      button.style.visibility = "hidden";
    });
  }

  // Check how many products remain and hide remove button if a single product remains
  const products = document.querySelectorAll(".attributesWrapper");
  const productCount = products.length;

  if (productCount > 1) {
    showRemovalButtons();
  } else {
    hideRemovalButtons();
  }
}
   
//
// ––––––––––––––––––––––––––––––––––––––––
// FORM VALIDATION
// ––––––––––––––––––––––––––––––––––––––––
//

// Function to check if all fields are filled
function checkFields() {
  
  // -- only get fields that are not hidden -- //

  const fields = document.querySelectorAll(".customOrderForm input:not([type='hidden'])");
  const submitButton = document.getElementById("submitButton");

  // Check if all fields have a value
  const allFilled = Array.from(fields).every((field) => field.value.trim() !== "");

  // Enable/disable submit button
  if (allFilled) {
    submitButton.classList.add("submitButtonActive");
    populateHiddenFields();
    submitButton.disabled = false;
  } else {
    submitButton.classList.remove("submitButtonActive");
    submitButton.disabled = true;
  }
}
// Attach event listeners for form validaton
function formValidation() {
  document.querySelectorAll("input").forEach((field) => {
    field.addEventListener("input", checkFields);
  });
}
formValidation();
checkFields();

//
// –
// Populate Hidden Fields
// –
//

/*
function populateHiddenFields() {

  console.log( "populateHiddenFields" );
  // -- this is a bit hacky but it works for now -- //

  const lineItems = [];

  // get all divs with a class of 'attributesWrapper' and loop through them
  const products = document.querySelectorAll(".attributesWrapper");

  // loop through each product we need to add each product to the cart hidden field

  for (let i = 0; i < products.length; i++) {
   
    // get product shape
    const productShape = document.getElementById(`productShape-${i}`);
    if( !productShape ) return;

    // get product design
    const productDesign = document.getElementById(`productDesign-${i}`).value;
    if( !productDesign ) return;

    // get product colour
    const productColour = document.getElementById(`productColour-${i}`).value;
    if( !productColour ) return;

    // get product quantity
    const productQuantity = document.getElementById(`productQuantity-${i}`).value;
    if( !productQuantity ) return;

    // get product subtotal
    const productSubtotal = document.getElementById(`subtotal-${i}`).innerHTML;
    if( !productSubtotal ) return;

    // -- lets build our line item string 
    const lineItem = `--- Product ${i+1} ---
      ${productShape.value}
      ${productDesign.value}
      ${productColour.value}
      Packs: ${productQuantity.value} 
      Subtotal: €${productSubtotal.value}`;

    // push this line item to the lineItems array
    lineItems.push(lineItem);

  }

  // -- now we have all the line items we can add them to the hidden field

  // get the hidden field
  const hiddenField = document.getElementById("cart");

  // set the value of the hidden field to the line items array
  hiddenField.value = lineItems.join("\n\n");



}
});
*/


function populateHiddenFields() {
  console.log("populateHiddenFields");

  const lineItems = [];
  const products = document.querySelectorAll(".attributesWrapper");

  for (let i = 0; i < products.length; i++) {
    const shapeEl = document.getElementById(`productShape-${i}`);
    const designEl = document.getElementById(`productDesign-${i}`);
    const colourEl = document.getElementById(`productColour-${i}`);
    const qtyEl = document.getElementById(`productQuantity-${i}`);
    const subtotalEl = document.getElementById(`subtotal-${i}`);

    // Skip if any key element is missing
    if (!shapeEl || !designEl || !colourEl || !qtyEl || !subtotalEl) continue;

    // Get values safely
    const productShape = shapeEl.value || "";
    const productDesign = designEl.value || "";
    const productColour = colourEl.value || "";
    const productQuantity = qtyEl.value || "";
    const productSubtotal = subtotalEl.textContent || "";

    // Build readable line item string
    const lineItem = `--- Product ${i + 1} ---
${productShape}
${productDesign}
${productColour}
Packs: ${productQuantity}
Subtotal: ${productSubtotal}`;

    lineItems.push(lineItem);
  }

  // Add to hidden field
  const hiddenField = document.getElementById("cart");
  hiddenField.value = lineItems.join("\n\n");
}

});